import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import TextArea from 'components/shared/debouncedTextArea';

const FeedbackCommentBox = ({ onCommentChange, commentValue, disabled }) => {
  return (
    <>
      <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD} className="as-b">
        {t('practice.role_play.partner_guide.comment_title')}
      </Text>
      <TextArea
        placeholder={t('practice.role_play.partner_guide.comment_placeholder')}
        className="mb-32 mt-12 minh-150 w-100p p-16 bg-gray-lightest border border-gray bdrs-2"
        onChange={e => onCommentChange(e)}
        value={commentValue}
        disabled={disabled}
      />
    </>
  );
};

export default FeedbackCommentBox;
